import React, { useState, useEffect, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { BASE_API } from '../../api/Globals';
import Menu from '../../components/sturtural/Menu';
import { InputText } from 'primereact/inputtext';
import { InputSwitch } from 'primereact/inputswitch';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useNavigate } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { helpHttp } from '../../helpers/helpHttp';
import { Toast } from 'primereact/toast';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import DialogDocumento from '../../components/dialogs/DialogDocumento';
import DialogEditarEvidencia from '../../components/dialogs/DialogEditarEvidencia';
import { defaults } from 'chart.js';
import { storage } from '../../helpers/storage';


const estatus = [
    { label: 'Todos los estatus', value: 0 },
    { label: 'Pendientes', value: 2 },
    { label: 'Cargados', value: 1 },
];

const semaforo = [
    { label: 'Todos los estatus', value: '0' },
    { label: <><i className="pi pi-circle-fill mr-2" style={{ color: '#ad3737' }} /> <label>Más de 10 días sin atención</label></>, value: 'rojo' },
    { label: <><i className="pi pi-circle-fill mr-2" style={{ color: '#d7bb22' }} /> <label>De 1 a 10 días sin atención</label></>, value: 'amarillo' },
    { label: <><i className="pi pi-circle-fill mr-2" style={{ color: '#477d47' }} /> <label>Evidencias cargadas</label></>, value: 'verde' },
    { label: <><i className="pi pi-circle-fill mr-2" style={{ color: '#a5a5a5' }} /> <label>Sin cierre de entrega</label></>, value: 'gris' },
];

const getReporte = [
    { label: 'General', value: 1 },
    { label: 'Por nivel', value: 2 },
    { label: 'Por CT', value: 3 },
];

const getEntrega = [
    { name: 'Focalizado', code: 1 },
    { name: 'Sede', code: 2 },
];

const initEstadistico = {
    TotalEnviadas: "0",
    TotalEscuelasEnFolio: "0",
    TotalEnEvidenciaCT: "0",
    TotalFaltantes: "0",
    Porcentaje: "0"
}

const initForm = {
    tipoReporte: getReporte[0].value,
    municipio: null,
    localidad: null,
    nivel: null,
    tipoEntrega: getEntrega[0],
    ct: '',
    estatus: estatus[0].value,
    semaforo: semaforo[0].value

}


const ReporteEvidencias = () => {
    const navigate = useNavigate();
    const [municipios, setMunicipios] = useState([]);
    // const [getReporte, setGetReporte] = useState([]);
    const [getLocalidad, setGetLocalidad] = useState([]);
    const [getNivel, setGetNivel] = useState([]);
    // const [getUniverso, setGetUniverso] = useState([]);
    // const [municipio, setMunicipio] = useState(null);
    // const [ct, setCt] = useState('');
    // const [estado, setEstado] = useState(estatus[0].value)
    const [form, setForm] = useState(initForm)
    const [loading, setLoading] = useState(false);
    const [loadingBuscar, setLoadingBuscar] = useState(false);
    const [loadingEstadistico, setLoadingEstadistico] = useState(false);
    const [loadingInv, setLoadingInv] = useState(false);
    const [aviso, setAviso] = useState(false);
    const [message, setMessage] = useState(false);
    const [evidencias, setEvidencias] = useState(null)
    const [dialogDocument, setDialogDocument] = useState(false);
    const [openDialogEvidencia, setOpenDialogEvidencia] = useState(false);
    const [documentos, setDocumentos] = useState([])
    const [dataEvidencias, setDataEvidencias] = useState(null);
    const [objEstadistico, setObjEstadistico] = useState(initEstadistico);
    const perfil = storage.get('perfilid');
    const id = storage.get("id");
    const ciclo = storage.get('ciclo');
    const toast = useRef(null);
    const [totalCtsEvidencias, setTotalCtsEvidencias] = useState(0)



    useEffect(() => {
        if (![1, 5, 3, 19, 20, 21].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    useEffect(() => {
        async function obtenerDrops() {
            const resMuni = await helpHttp().post(`${BASE_API}Escuela/CargarMunicipios`, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                const todos = { IdMunicipio: 0, Municipio: 'Todos los municipios' }
                res.unshift(todos);
                setMunicipios(res);
                return res
            })

            const resNivel = await helpHttp().get(`${BASE_API}BusquedaAlumnos/GetRptNivel`, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                setGetNivel(res.ITEMS.ITEMS);
                return res.ITEMS.ITEMS
            })

            setForm({ ...form, municipio: resMuni[0], nivel: resNivel[0] })
        }
        obtenerDrops();
        obtenerEstadistico();
    }, [])

    const obtenerEstadistico = () => {
        setLoadingEstadistico(true)
        helpHttp().post(`${BASE_API}Reportes/estadisticas`, {
            body: {
                IdCicloEscolar: ciclo.IdCicloEscolar,
                IdFolioMaquila: 0,
                IdTipoMaquila: 0,
                ParametrosExtra: ""
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                const resultado = calcularPorcentajesSeguro(res.ITEMS[0]);
                setObjEstadistico(resultado)
            }
            setLoadingEstadistico(false);
        })
    }

    const calcularPorcentajesSeguro = (objeto) => {
        const total = objeto.TotalEscuelasEnFolio;

        if (total === 0) {
            return {
                ...objeto,
                Porcentaje: "0%",
            };
        }

        return {
            ...objeto,
            Porcentaje: parseFloat(((objeto.TotalEnviadas / total) * 100).toFixed(2)) + "%",
        };
    }

    const handlerRedirect = () => {
        setAviso(false);
    }

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setForm({
            ...form,
            [name]: value,
        })
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            // console.log(module)
            // if (module && module.default) {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            });

            module.saveAs(data, fileName + EXCEL_EXTENSION);
            // }
        });
        setLoading(false)
    };


    const GenerarReporte = () => {
        setLoading(true);

        if (form.municipio !== null) {
            helpHttp().post(`${BASE_API}Reportes/spdReportes`, {
                body: {
                    Opcion: 2,
                    ParametrosExtra: `[{
                        "IdCicloEscolar": ${ciclo.IdCicloEscolar},
                        "IdMunicipio": ${form.ct.trim().length === 0 ? form.municipio.IdMunicipio : 0},
                        "IdNivel": ${form.ct.trim().length === 0 ? form.nivel.code : 0},
                        "CCT": "${form.ct.trim()}"
                }]`
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCESS) {
                    let excel = res.ITEMS;

                    let temp = 'data:application/vnd.ms-excel;base64,' + encodeURIComponent(excel);
                    let download = document.createElement('a');
                    download.href = temp;
                    download.download = `ReporteEvidencias_Ciclo_${ciclo.Descripcion}.xlsx`;
                    document.body.appendChild(download);
                    download.click();
                    document.body.removeChild(download);

                    setLoading(false);
                } else {
                    setMessage(res.ITEMS.MESSAGE);
                    setAviso(true);

                    setLoading(false);
                }
            })
        }
    }

    const obtenerEvidencias = () => {
        setLoadingBuscar(true);
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: 'SpdRptCTEvidencias',
                opcion: 0,
                parametros: [
                    { "IdCicloEscolar": ciclo.IdCicloEscolar },
                    { "IdMunicipio": form.ct.trim().length === 0 ? form.municipio.IdMunicipio : 0 },
                    { "IdNivel": form.ct.trim().length === 0 ? form.nivel.code : 0 },
                    { "CCT": form.ct.trim() },
                    { "IdEstatus": form.ct.trim().length === 0 ? form.estatus : 0 },
                    { "IdSemaforo": form.ct.trim().length === 0 ? form.semaforo : '0' },
                    { "ParametrosExtra": '' }
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                setTotalCtsEvidencias(res.ITEMS.length)
                res?.ITEMS[0]?.Municipio == "" ?
                    setEvidencias(null)
                    :
                    setEvidencias(res.ITEMS)
            }
            setLoadingBuscar(false);
        })
    }

    const listarAdjuntos = (detalle) => {
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "SpdListarEvidenciasCTMaquila",
                opcion: 0,
                parametros: [
                    { "Folio": detalle["Folio maquila"] },
                    { "CCT": detalle["Clave CT"] },
                    { "IdCicloEscolar": ciclo.IdCicloEscolar }
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                const data = res.ITEMS.map(x => {
                    return {
                        ...x,
                        TipoArchivo: x.tipoArchivo,
                        idFolioMaquila: x.Folio,
                        IdCicloEscolar: x.idCicloEscolar,
                    }
                })
                setDocumentos(data)
                setDialogDocument(true);
            }
        })
    }

    const handleChamge_switch = (rowData) => {
        const activar = rowData['Habilitar edicion'] === 'Sí' ? true : false
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "SpdHabilitarEdicion",
                opcion: 2,
                parametros: [
                    { 'FolioMaquila': rowData['Folio maquila'] },
                    { 'Escuela': rowData['Clave CT'] },
                    { 'Habilitar': !activar },
                    { 'idCicloEscolar': ciclo.IdCicloEscolar },
                    { 'parametrosExtra': null }
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(async (res) => {
            if (res.ITEMS[0].succes) {
                setEvidencias(prev =>
                    prev.map(evidencia =>
                        evidencia['Clave CT'] === rowData['Clave CT']
                            ? { ...evidencia, ['Habilitar edicion']: !activar ? "Sí" : "No" }
                            : evidencia
                    )
                );
            }
        });
    }

    const limpiarFiltros = () => {
        setForm({ ...initForm, municipio: municipios[0], nivel: getNivel[0] });
        setEvidencias(null);
    }

    const municipioTemplate = (rowData) => {
        return (
            rowData["Clave CT"] &&
            <div>
                <label>{rowData["Localidad"]}, {rowData["Municipio"]}</label>
            </div>
        )
    }


    const ctTemplate = (rowData) => {
        return (
            rowData["Clave CT"] &&
            <div className='font-bold'>
                <label>{rowData["Clave CT"]} - {rowData["Nombre CT"]}</label> <br />
                <label>{rowData["Nivel"].substring(0, 1)}<label style={{ textTransform: 'lowercase' }}>{rowData["Nivel"].substring(1, rowData["Nivel"].lenght)}</label></label>
            </div>
        )
    }


    const totalAlumnosTemplate = (rowData) => {
        return (
            rowData["Clave CT"] &&
            <div>
                <label>En CT: {rowData["Total alumnos CT"]}</label><br />
                <label>En folio: {rowData["Total alumnos en folio"]}</label><br />
                <label>Entregados: {rowData["Total alumnos entregados"]}</label>
            </div>
        )
    }

    const folioEnEscuelaTemplate = (rowData) => {
        let folioEnEscuela = rowData["¿Folio en escuela?"]
        return (
            rowData["Clave CT"] &&
            <div className='text-center'>
                {folioEnEscuela == '-' ?
                    <div style={{ fontSize: '30px' }}> - </div>
                    :
                    <div> {folioEnEscuela} </div>
                }
            </div>
        )
    }


    const evidenciaTemplate = (rowData) => {
        let archivo = rowData["Archivo de evidencia"]
        return (
            rowData["Clave CT"] &&
            <div className='text-center'>
                {archivo == '-' ?
                    <div style={{ fontSize: '30px' }}> - </div>
                    :
                    <Tag rounded value={rowData["Archivo de evidencia"]} style={{ color: archivo == 'SÍ' ? '#036303' : '#9b2f3e', background: archivo == 'SÍ' ? '#03630338' : '#9b2f3e30', textTransform: 'uppercase', width: '50px' }}></Tag>
                }
            </div>
        )
    }


    const fechaEvidenciasTemplate = (rowData) => {
        let fecha = rowData["Fecha evidencia"]
        return (
            rowData["Clave CT"] &&
            <div className='text-center'>
                {fecha == '-' ?
                    <div style={{ fontSize: '30px' }}> - </div>
                    :
                    fecha.substring(0, 10)
                }
            </div>
        )
    }

    const fechaCierreTemplate = (rowData) => {
        let fecha = rowData["Fecha entrega"]
        return (
            rowData["Clave CT"] &&
            <div className='text-center'>
                {fecha == '-' ?
                    <div style={{ fontSize: '30px' }}> - </div>
                    :
                    fecha.substring(0, 10)
                }
            </div>
        )
    }

    const obtenerEditarEvidencias = async (detalle) => {
        setDataEvidencias(detalle)
        setOpenDialogEvidencia(true);
    }


    const accionesTemplate = (rowData) => {
        return (
            rowData["Clave CT"] &&
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Tooltip target=".p-tooltip-target" />
                <div className='p-tooltip-target flex' data-pr-tooltip={rowData["Habilitar edicion"] == true ? 'Desactivar eliminar' : 'Activar eliminar'} data-pr-position='top' style={{ alignItems: 'center' }}>
                    <InputSwitch className='mr-3' id='estilodeSwitc' checked={rowData['Habilitar edicion'] === "Sí" ? true : false} onChange={(e) => handleChamge_switch(rowData)} />
                </div>
                 <Button icon='pi pi-pencil' className="p-button-outlined p-0 p-tooltip-target mr-3" data-pr-tooltip="Editar evidencias" data-pr-position='top' style={{ fontSize: '30px', height: '35px', width: '35px' }}
                    onClick={() => obtenerEditarEvidencias(rowData)} />
{/*                 <Button disabled={rowData["Archivo de evidencia"] === "SI" || rowData["Archivo de evidencia"] === "SÍ" ? false : true} className='p-button-outlined p-tooltip-target' data-pr-tooltip='Ver adjuntos' data-pr-position='top' id='btn-accion' icon="pi pi-paperclip" style={{ width: '35px' }} onClick={() => listarAdjuntos(rowData)} /> 
 */}            </div>
        )
    }

    const SemaforoTemplate = (rowData) => {
        let colorIndicador = rowData["Indicador color"]
        let semaforoDias = rowData["Indicador días"]
        let evidencias = rowData["Archivo de evidencia"]
        let fechaCierre = rowData["Fecha entrega"]
        let colorSemaforo, colorLetra = ''

        switch (colorIndicador) {
            case 'rojo':
                colorSemaforo = '#ad37376e';
                colorLetra = '#5b0000';
                break;

            case 'amarillo':
                colorSemaforo = '#d7bb2270';
                colorLetra = '#594a00';
                break;

            case 'verde':
                colorSemaforo = '#477d4761';
                colorLetra = '#002500';
                break;

            case 'gris':
                colorSemaforo = '#d3d3d3';
                colorLetra = '#393939';
                break;

            default:
                colorSemaforo = '#d3d3d3';
                colorLetra = '#393939';
                break;
        }
        let tooltipSemaforo =
            evidencias == 'SÍ' ? 'Evidencias cargadas' :
                fechaCierre == '-' ? 'Sin cierre de entrega' :
                    semaforoDias + ' días sin atención'

        return (
            rowData["Clave CT"] &&
            <div className='text-center'>
                {/* <Tooltip target=".p-tooltip-target" /> */}
                <Tag rounded
                    value={rowData["Archivo de evidencia"]}
                    className='p-tooltip-target'
                    // data-pr-tooltip={tooltipSemaforo}
                    style={{ color: colorLetra, background: colorSemaforo, textTransform: 'uppercase', width: '50px' }} >
                </Tag>
            </div>
        )
    }

    const DiasTemplate = (rowData) => {
        let evidencias = rowData["Archivo de evidencia"]
        let fechaCierre = rowData["Fecha entrega"]
        let semaforoDias = rowData["Indicador días"]
        let diasSinAtencion = (evidencias == 'SÍ' || fechaCierre == '-') ? '-' : semaforoDias + ' días';

        return (
            <div className='text-center'>
                <div style={{ fontSize: diasSinAtencion == '-' ? '30px' : 'inherit' }}>{diasSinAtencion}</div>
            </div>
        )
    }



    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => handlerRedirect()} icon="pi pi-check" className="p-button-primary" />;

    return (
        <>
            <Menu link='reporte-general' />
            <Toast ref={toast} />
            <Tooltip target=".p-tooltip-target" />

            <h4 className='mb-4 mt-4' style={{ textAlign: 'center', marginTop: '10px' }}>GESTIÓN DE EVIDENCIAS CT</h4>

            <div className='card col-12' style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '10px', paddingBottom: '10px', marginBottom: '15px' }}>

                <div className='grid justify-content-center' style={{ marginTop: '1px' }}>
                    <div id='porcentajeEntrega' className='p-0 col-12 lg:col-2 md:col-6 sm:col-6 xs:col-6 flex justify-content-center lg:mb-0 md:mb-0 mb-2' style={{ borderRadius: '25px', background: '#efefef' }}>
                        <div style={{ justifyItems: 'center' }}>
                            <span style={{ fontWeight: '600', fontSize: '30px' }}>{loadingEstadistico ? <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i> : objEstadistico.TotalEnEvidenciaCT}</span>
                            <div className="font-small mb-1" style={{ textTransform: 'uppercase', fontWeight: '800' }}>TOTAL CTS</div>
                        </div>
                    </div>
                    <div id='porcentajeEntrega' className='col-12 lg:col-2 md:col-6 sm:col-6 xs:col-6 flex justify-content-center lg:mb-0 md:mb-0 mb-2'>
                        <i className={`pi pi-inbox text-2xl md:text-4xl`} style={{ color: '#9b2f3e', alignSelf: 'center', marginRight: '20px' }}></i>
                        <div id='contendorEstadistico' /* style={{ minWidth: '120px' }} */>
                            <span className="text-900 font-medium text-3xl">{loadingEstadistico ? <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i> : objEstadistico.TotalFaltantes}</span>
                            <div className="text-900 font-small mb-1" style={{ textTransform: 'uppercase' }}>PENDIENTES</div>
                        </div>
                    </div>
                    <div id='porcentajeEntrega' className='col-12 lg:col-2 md:col-6 sm:col-6 xs:col-6 flex justify-content-center lg:mb-0 md:mb-0 mb-2'>
                        <i className={`pi pi-check-circle text-2xl md:text-4xl`} style={{ color: '#9b2f3e', alignSelf: 'center', marginRight: '20px' }}></i>
                        <div id='contendorEstadistico' /* style={{ minWidth: '120px' }} */>
                            <span className="text-900 font-medium text-3xl">{loadingEstadistico ? <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i> : objEstadistico.TotalEnviadas}</span>
                            <div className="text-900 font-small mb-1" style={{ textTransform: 'uppercase' }}>CARGADOS</div>
                        </div>
                    </div>
                    <div id='porcentajeEntrega' className='col-12 lg:col-2 md:col-6 sm:col-6 xs:col-6 flex justify-content-center lg:mb-0 md:mb-0 mb-2'>
                        <i className={`pi pi-chart-line text-2xl md:text-4xl`} style={{ color: '#9b2f3e', alignSelf: 'center', marginRight: '20px' }}></i>
                        <div id='contendorEstadistico' /* style={{ minWidth: '120px' }} */>
                            <span className="text-900 font-medium text-3xl">{loadingEstadistico ? <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i> : objEstadistico.Porcentaje}</span>
                            <div className="text-900 font-small mb-1" style={{ textTransform: 'uppercase' }}>PORCENTAJE DE AVANCE</div>
                        </div>
                    </div>
                    {/* <div id='porcentajeEntrega' className='col-12 lg:col-2 md:col-6 sm:col-6 xs:col-6 flex justify-content-center lg:mb-0 md:mb-0 mb-2'>
                        <i className={`pi pi-list text-2xl md:text-4xl`} style={{ color: '#9b2f3e', alignSelf: 'center', marginRight: '20px' }}></i>
                        <div id='contendorEstadistico'>
                            <span className="text-900 font-medium text-3xl">{loadingEstadistico ? <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i> : objEstadistico.TotalEscuelasEnFolio}</span>
                            <div className="text-900 font-small mb-1" style={{ textTransform: 'uppercase' }}>CTS EN MAQUILA</div>
                        </div>
                    </div> */}
                </div>

            </div>


            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <div className="p-fluid formgrid grid p-3 lg:mx-5 md:mx-5" style={{ background: '#efefef', border: '1px solid #dee2e6', borderRadius: '10px' }}>
                            <div className="field col-12 lg:col-2 md:col-6 mb-1 lg:mb-0">
                                <Dropdown id="semaforo" value={form.semaforo || semaforo[0].value} options={semaforo} name="semaforo" optionLabel="label" placeholder="Elige un indicador" onChange={handleOnChange} />
                            </div>
                            {/* <div className="field col-12 lg:col-2 md:col-6 mb-1 lg:mb-0">
                                <Dropdown id="estatus" value={form.estatus || estatus[0].value} options={estatus} name="estatus" optionLabel="label" placeholder="Elige un estatus" filter onChange={handleOnChange} />
                            </div> */}
                            <div className="field col-12 lg:col-2 md:col-6 mb-1 lg:mb-0">
                                <Dropdown id="municipio" value={form.municipio} options={municipios} name="municipio" optionLabel="Municipio" placeholder="Elige un municipio" filter onChange={handleOnChange} />
                            </div>
                            <div className="field col-12 lg:col-2 md:col-6 mb-1 lg:mb-0">
                                <Dropdown id="nivel" value={form.nivel} options={getNivel} name="nivel" optionLabel="name" placeholder="Elige un nivel" onChange={handleOnChange} />
                            </div>
                            <div className="field col-12 lg:col-3 md:col-6 mb-1 lg:mb-0">
                                <InputText id='ct' name='ct' value={form.ct} placeholder='Buscador por CT' onChange={handleOnChange} />
                            </div>
                            <div className="field col-12 lg:col-3 md:col-6 mb-1 lg:mb-0 mt-2 lg:mt-0 flex" style={{ alignItems: 'center' }}>
                                <Button className='p-button' type='button' label="Buscar" name="button-buscar" id="button-buscar" loading={loadingBuscar} style={{ width: '90px' }} onClick={() => obtenerEvidencias()} />
                                <Button className='p-button-outlined ml-2' type='button' label="Limpiar" name="button-limpiar" id="button-limpiar" style={{ width: '90px' }} onClick={() => limpiarFiltros()} />
                                <Button icon='pi pi-download' className='p-button ml-1 pt-1' tooltip="Descargar excel" data-pr-position="top" style={{ color: '#FFFFFF', background: '#9b2f3e' }} rounded text disabled={loading} onClick={() => GenerarReporte()} />
                            </div>
                        </div>

                        {/*   <div className='grid mt-3 mb-2 lg:mx-5 md:mx-5'>
                            <div className='col-6' style={{alignContent: 'center'}}>
                                Total <label style={{fontWeight: 700}}>{totalCtsEvidencias} </label> 
                            </div>
                            <div className='col-6  text-right'>
                                <Button type='button' className='p-button-excel p-tooltip-target' data-pr-tooltip="Descargar excel" data-pr-position="left" name="button-generar" id="button-generar" disabled={loading} onClick={() => GenerarReporte()} >
                                    <img src='./assets/layout/images/excelLogo1.png' style={{ width: '25px' }}></img>
                                </Button>
                            </div>
                        </div>
 */}
                        <div id='tablaMaquila' className='lg:mx-5 md:mx-5' style={{ border: '1px solid #c8cccf' }}>

                            <DataTable
                                className='p-datatable'
                                value={evidencias}
                                loading={loadingBuscar}
                                emptyMessage='Sin registros. Intente otra búsqueda.'
                                breakpoint="960px"
                                paginator
                                rows={10}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="Mostrando del {first} al {last} de {totalRecords}">
                                <Column header="Estatus carga de evidencias" headerStyle={{ justifyItems: 'center' }} style={{ textAlign: 'center' }} body={SemaforoTemplate} />
                                <Column header="Folio maquila" field='Folio maquila' />
                                <Column header="CT" body={ctTemplate} style={{ fontWeight: 'bold' }} />
                                <Column header="Localidad/Municipio" body={municipioTemplate} />
                                <Column header="Total alumnos" body={totalAlumnosTemplate} />
                                <Column header="Fecha cierre entrega" headerStyle={{ justifyItems: 'center' }} style={{ textAlign: 'center' }} body={fechaCierreTemplate} />
                                <Column header="Fecha carga evidencias" headerStyle={{ justifyItems: 'center' }} style={{ textAlign: 'center' }} body={fechaEvidenciasTemplate} />
                                <Column header="Días sin atención" headerStyle={{ justifyItems: 'center' }} style={{ textAlign: 'center' }} body={DiasTemplate} />
                                <Column header="Acciones" headerStyle={{ justifyItems: 'center' }} style={{ textAlign: 'center' }} body={accionesTemplate} />
                            </DataTable>
                        </div>

                    </div>
                </div>
            </div>

            <Dialog header="Aviso" draggable={false} closable={false} visible={aviso} onHide={() => setMessage(false)} style={{ width: '400px' }} modal className="p-fluid" footer={basicDialogFooter}>
                <p>{message && message}</p>
            </Dialog>

            <DialogDocumento header="VISUALIZACIÓN DE ADJUNTOS" visible={dialogDocument} onHide={() => setDialogDocument(!dialogDocument)} data={documentos} idUsuario={id} idUsuarioPerfil={perfil}></DialogDocumento>

            <DialogEditarEvidencia visible={openDialogEvidencia} esAdministrador={true} data={dataEvidencias} onHide={() => {
                setOpenDialogEvidencia(!openDialogEvidencia);
                setDataEvidencias(null);
                obtenerEvidencias();
            }} />
        </>
    )
}

export default ReporteEvidencias;